import { render, staticRenderFns } from "./ChildSupportDetails.vue?vue&type=template&id=7df876e0"
import script from "./ChildSupportDetails.vue?vue&type=script&lang=js"
export * from "./ChildSupportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports